
// 全局自定义拖拽组件
export default (Vue) => {
    Vue.directive('zoom', {
        //1.指令绑定到元素上回立刻执行bind函数，只执行一次
        //2.每个函数中第一个参数永远是el，表示绑定指令的元素，el参数是原生js对象
        bind: function (el, elementObj) {
            let zoomBox = el; //获取当前元素
            let scal = 1
            zoomBox.onmousewheel = ev => {
                ev = ev || window.event;
                let down = true; // 定义一个标志，当滚轮向下滚时，执行一些操作
                down = ev.wheelDelta ? ev.wheelDelta < 0 : ev.detail > 0;
                if (down) {
                    // console.log("鼠标滚轮向下放大---------");
                    scal = (parseFloat(scal) + 0.1).toFixed(2);
                    // console.log("放大系数: " + scal);
                    zoomBox.style.transform = `scale(${scal})`;
                    zoomBox.style.transformOrigin = "center center";
                } else {
                    // console.log("鼠标滚轮向上缩小++++++++++");
                    if (scal == 0.1) {
                        scal = 0.1;
                        return;
                    } else {
                        scal = (parseFloat(scal) - 0.1).toFixed(2);
                    }
                    zoomBox.style.transform = `scale(${scal})`;
                    zoomBox.style.transformOrigin = "center center";
                }
                if (ev.preventDefault) {
                    /*FF 和 Chrome*/
                    ev.preventDefault(); // 阻止默认事件
                }
                return false;
            };
        }
    });
}
